import styled from 'styled-components'
import { G } from '@/components/gold/theme'

/** gold8.bet PC 하단 — 바탕 #1a242d, 위아래 32/30px, 본문 폭 1200px */
export const FooterRoot = styled.div`
  background: ${G.panel};
`

export const Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1200px;
  max-width: calc(100% - 40px);
  margin: 0 auto;
  padding: 32px 0 30px;
`

export const Copy = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  color: ${G.sand};
`
